import { render, staticRenderFns } from "./RemoveCard.vue?vue&type=template&id=4d9463e2&scoped=true&"
import script from "./RemoveCard.vue?vue&type=script&lang=js&"
export * from "./RemoveCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9463e2",
  null
  
)

export default component.exports